import layout from '@/layout'

export default {
  path: '/config',
  component: layout,
  redirect: '/config/other',
  name: 'config_other',
  meta: {
    title: 'config',
    icon: 'config'
  },
  children: [
    {
      path: '/config/other',
      name: 'config_other',
      component: () => import('@/views/config/other/index'),
      meta: {
        title: 'config_other',
        icon: 'config'
      }
    }
  ]
}
